import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackTranscriptSearchNextResultClicked.meta';

export type UseTrackTranscriptSearchNextResultClickedParams = {
  clip_id: string;
  search_term: string;
  new_index: number;
};

export const useTrackTranscriptSearchNextResultClicked = () => {
  const { track } = useAnalyticsUtilities();

  const trackTranscriptSearchNextResultClicked = useCallback(
    (params: UseTrackTranscriptSearchNextResultClickedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackTranscriptSearchNextResultClicked };
};
